import LoadingBall from 'components/LoadingBall';

const styles = {
  loadingBall: {
    margin: 'auto',
  },
};

const CenteredLoadingBall = () => (
  <div
    style={{
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    }}
  >
    <LoadingBall style={styles.loadingBall} />
  </div>
);

export default CenteredLoadingBall;
